import styled from 'styled-components/macro'

import { Banner, SpinnerWheel, Layout } from '@loadsmart/miranda-react'

import { RequestStatus } from 'core/domain/Request'
import { Icon, type IconProps } from 'core/ui/components/icon/Icon'

import { formatBannerByStatus } from '../presenter/spotQuotePresenter'

const StyledBanner = styled(Banner)<{ $hideCancel: boolean }>`
  max-width: 750px;
  width: ${({ $hideCancel }) => ($hideCancel ? 'fit-content' : 'auto')};
`

export type BookNowBannerProps = {
  rate?: string
  onCancel?: () => void
  onConfirm?: () => void
  bookNowStatus: RequestStatus
}

export function BookNowBanner({ rate, onCancel, onConfirm, bookNowStatus }: BookNowBannerProps) {
  const bannerContent = formatBannerByStatus({ bookNowStatus, rate })
  return (
    <StyledBanner variant={bannerContent.variant} $hideCancel={!onCancel}>
      <Banner.Icon>
        <Icon
          name={bannerContent.icon}
          size={24}
          color={`${bannerContent.variant}-dark` as IconProps['color']}
        />
      </Banner.Icon>
      <Banner.Title>
        <Layout.Group align="center">
          {bannerContent.description}
          {bookNowStatus === RequestStatus.Pending && <SpinnerWheel size={'16px'} />}
        </Layout.Group>
      </Banner.Title>
      {bookNowStatus === RequestStatus.Initial && (
        <Banner.Actions>
          {onCancel && (
            <Banner.ActionSecondary onClick={onCancel}>
              Send another proposal
            </Banner.ActionSecondary>
          )}
          <Banner.ActionPrimary
            onClick={onConfirm}
            disabled={!rate}
            data-testid="banner-confirm-book-now"
          >
            Book Now
          </Banner.ActionPrimary>
        </Banner.Actions>
      )}
    </StyledBanner>
  )
}
